import { render, staticRenderFns } from "./CmgDualPromoBanner.vue?vue&type=template&id=330dfc7e&scoped=true&lang=pug"
import script from "./cmg-dual-promo-banner.ts?vue&type=script&lang=ts&external"
export * from "./cmg-dual-promo-banner.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgDualPromoBanner.vue?vue&type=style&index=0&id=330dfc7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330dfc7e",
  null
  
)

export default component.exports